import React, { FC, SVGProps } from 'react';

interface LinkedInProps extends SVGProps<SVGSVGElement> {
  backgroundColor?: string;
}

export const LinkedIn: FC<LinkedInProps> = ({
  backgroundColor,
  fill,
  ...props
}) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={backgroundColor || '#26313B'} />
    <path
      d="M31.6042 31.6048H28.4037V26.5927C28.4037 25.3974 28.3824 23.8588 26.7392 23.8588C25.0723 23.8588 24.8172 25.1611 24.8172 26.5056V31.6045H21.6168V21.2974H24.6892V22.706H24.7322C25.0397 22.1802 25.484 21.7477 26.0178 21.4545C26.5517 21.1613 27.155 21.0184 27.7636 21.041C31.0074 21.041 31.6055 23.1747 31.6055 25.9505L31.6042 31.6048ZM18.0056 19.8885C17.6383 19.8886 17.2792 19.7797 16.9737 19.5757C16.6683 19.3716 16.4302 19.0816 16.2895 18.7422C16.1489 18.4029 16.112 18.0294 16.1836 17.6692C16.2552 17.3089 16.4321 16.9779 16.6918 16.7181C16.9515 16.4583 17.2824 16.2813 17.6426 16.2096C18.0029 16.1379 18.3763 16.1746 18.7157 16.3151C19.0551 16.4556 19.3452 16.6936 19.5493 16.999C19.7535 17.3044 19.8625 17.6635 19.8625 18.0308C19.8626 18.2747 19.8146 18.5163 19.7213 18.7416C19.628 18.967 19.4912 19.1718 19.3188 19.3443C19.1464 19.5168 18.9416 19.6536 18.7163 19.747C18.491 19.8404 18.2495 19.8884 18.0056 19.8885ZM19.6058 31.6048H16.4021V21.2974H19.6058V31.6048ZM33.1997 13.2017H14.7938C14.3761 13.197 13.9735 13.3583 13.6746 13.6502C13.3758 13.9422 13.205 14.3408 13.2 14.7586V33.2415C13.2049 33.6594 13.3755 34.0584 13.6744 34.3506C13.9732 34.6429 14.3759 34.8045 14.7938 34.8001H33.1997C33.6185 34.8053 34.0223 34.6441 34.3223 34.3519C34.6224 34.0597 34.7942 33.6603 34.8 33.2415V14.7573C34.794 14.3387 34.6221 13.9396 34.322 13.6476C34.022 13.3557 33.6183 13.1948 33.1997 13.2003"
      fill={fill || 'white'}
    />
  </svg>
);
